import React from 'react'
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { containerVariants, itemVariants } from "../../variants/variants";



const Section2 = () => {
    const { t } = useTranslation();
    
    return (
        <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className="w-full h-96   flex items-center justify-center  flex-col text-customBlack">
            <motion.h2
                variants={itemVariants}
                className="text-65">
                <span className="font-medium">{t("sustainability.employees.title")}</span>{" "}
                <span className="font-light">{t("sustainability.employees.subtitle")}</span>
            </motion.h2>
            <motion.h2
            variants={itemVariants}
            className="text-30">
                <span className="font-medium">{t("sustainability.employees.society")}</span>{" "}
                <span className="font-light">{t("sustainability.employees.societySubtitle")}</span>
            </motion.h2>
        </motion.div>
    )
}

export default Section2